"use strict";

var Client = require('./client');
module.exports = function (cfg) {
  var fetcher = function fetcher(input, init) {
    return fetch(input, init);
  };
  return new Client(cfg, {
    fetch: fetcher
  });
};